import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-news-create",
  templateUrl: "./college-news-create.component.html",
  styleUrls: ["./college-news-create.component.scss"],
})
export class CollegeNewsCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  colleges = []; // Add this array to store colleges

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";

    // Load colleges for dropdown
    this.loadColleges();

    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      if (id) {
        this.loadNewsData(id);
      }
    });

    this.Form = this.formBuilder.group({
      newsdate: ["", [Validators.required]],
      title: ["", [Validators.required]],
      college: ["", Validators.required],
      image: ["", Validators.required],
      description: ["", Validators.required],
      _id: [""],
    });
    if (this.record) {
      this.action = "Update";
      this.Form.patchValue(this.record);
    } else {
      this.action = "Submit";
      this.Form.patchValue({ college: this.collegeId });
    }
  }

  // Load colleges for dropdown
  loadColleges() {
    this.http
      .get<any>(`${environment.apiUrl}/college/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.colleges = data.results || [];
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading colleges:", err);
        }
      );
  }

  // Load news data for editing
  loadNewsData(id: string) {
    this.http
      .get<any>(`${environment.apiUrl}/collegenews/${id}`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }

          if (data) {
            this.action = "Update";
            this.Form.patchValue({
              _id: data._id,
              newsdate: data.newsdate,
              title: data.title,
              college: data.college, // This should now be the college ID
              image: data.image,
              description: data.description,
            });
          }
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading news:", err);
        }
      );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    const data = {
      title: this.Form.value.title,
      newsdate: this.Form.value.newsdate,
      college: this.Form.value.college, // This is now the college ID
      description: this.Form.value.description,
      image: this.Form.value.image,
    };

    if (this.action == "Submit") {
      this.http
        .post<any>(`${environment.apiUrl}/collegenews/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            this.handleResponse(res);
          },
          (err: HttpErrorResponse) => {
            this.handleError(err);
          }
        );
    } else {
      let id = this.Form.value._id;
      this.http
        .patch<any>(`${environment.apiUrl}/collegenews/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            this.handleResponse(res);
          },
          (err: HttpErrorResponse) => {
            this.handleError(err);
          }
        );
    }
  }

  private handleResponse(res: any) {
    if (res.message == "Logged Out!") {
      this.router.navigateByUrl("/auth/login");
      return;
    }

    if (res.status == "500") {
      this.message = res.message;
      this.class = "btn-primary rounded px-1 py-1";
      window.scrollTo(document.documentElement.clientWidth, 0);
    } else {
      this.message = this.action === "Submit" ? "Successfully Added" : "Successfully Updated";
      this.class = "btn-success rounded px-1 py-1";
      this.router.navigateByUrl("/college-details/college-news-list");
      this.formSaved.emit();   // ✅ emit on success
    }
  }

  private handleError(err: HttpErrorResponse) {
    if (err.error instanceof Error) {
      console.log("Client-side error occurred.");
    } else {
      console.log("Server-side error occurred.");
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-address-list");
    }
  }
}